import { ApiPaths } from 'api/constants';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import {
  IInvitationsRepo,
  InvitedUserGeneral,
  InviteParams,
} from './IInvitations';

export class InvitationsRepo extends BaseRepo implements IInvitationsRepo {
  getInvitations = (): ApiResponseAsync<DataWithTotal<InvitedUserGeneral>> =>
    this.helpers.handleGet(ApiPaths.invitations._());

  inviteUser = (params: InviteParams): ApiResponseAsync<unknown> =>
    this.helpers.handlePostAction(ApiPaths.invitations._(), params);

  resendInvitation = (
    invitation: InvitedUserGeneral
  ): ApiResponseAsync<unknown> =>
    this.helpers.handlePostAction(
      ApiPaths.invitations.byId.resend._({
        [ApiUrlParams.invitationId]: invitation.id,
      }),
      null
    );

  revokeInvitation = (
    invitation: InvitedUserGeneral
  ): ApiResponseAsync<unknown> =>
    this.helpers.handleDelete(
      ApiPaths.invitations.byId._({
        [ApiUrlParams.invitationId]: invitation.id,
      })
    );
}
